const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotarinIconVererben(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 561 593",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-10.8316,-647.611)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,642.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grabstein"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1.83886,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.139,455.611C115.139,455.611 114,187.03 114,180.25C114,83.665 192.415,5.25 289,5.25C385.585,5.25 464,83.665 464,180.25L464,455.611L115.139,455.611ZM131.971,438.707C131.971,438.707 447.096,438.707 447.096,438.707L447.096,180.25C447.096,92.994 376.256,22.154 289,22.154C201.744,22.154 130.904,92.994 130.904,180.25C130.904,185.996 131.722,379.776 131.971,438.707Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.998522,0,0,1,0.429977,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516.172,501.193L516.172,589.193L65.506,589.193L65.506,501.193L516.172,501.193ZM499.243,518.097L82.435,518.097L82.435,572.289C82.435,572.289 499.243,572.289 499.243,572.289L499.243,518.097Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.00403,0,0,1,-3.8504,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500.172,440.748L500.172,514.526L86.839,514.526L86.839,440.748L500.172,440.748ZM483.336,457.652L103.675,457.652L103.675,497.622C179.23,497.622 483.336,497.622 483.336,497.622L483.336,457.652Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.727485,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.455,146.098L268.455,108.765L313.789,108.765L313.789,146.098L348.455,146.098L348.455,188.765L313.789,188.765L313.789,268.765L268.455,268.765L268.455,188.765L234.677,188.765L234.677,146.098L268.455,146.098ZM268.455,163.002L251.581,163.002C251.581,163.002 251.581,171.861 251.581,171.861L268.455,171.861C277.791,171.861 285.359,179.429 285.359,188.765L285.359,251.861L296.885,251.861L296.885,188.765C296.885,179.429 304.453,171.861 313.789,171.861L331.551,171.861L331.551,163.002L313.789,163.002C304.453,163.002 296.885,155.434 296.885,146.098L296.885,125.669L285.359,125.669L285.359,146.098C285.359,155.434 277.791,163.002 268.455,163.002Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.284,589.193L562.394,589.193",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.506,318.971L276.172,318.971",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.506,353.637L371.283,353.637",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.506,384.749L371.283,384.749",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.972448,0,11.1147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.617,205.193L160.617,403.415",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "17.14px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.617,175.86L160.617,186.526",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotarinIconVererben);
export default __webpack_public_path__ + "static/media/Notarin_Icon_Vererben.6dd6d9656df7c94e1adea624eda09dbb.svg";
export { ForwardRef as ReactComponent };